interface APIKeyInterface {
  keys: string[];
}

export class APIKey implements APIKeyInterface {
  keys: string[];

  constructor(keys: string[]) {
    this.keys = keys;
  }

  getKey(index: number): string | undefined {
    return this.keys[index];
  }
}
